import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  CUSTOM_SHADOW_MAX_DISTANCE,
  CUSTOM_SHADOW_MIN_DISTANCE,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-custom-shadow-distance-option/base-item-custom-shadow-distance-option.types';

interface BaseItemCustomShadowDistanceOptionProps {
  dropShadowDistance: number;
  className?: string;
  onUpdateDistance(dropShadowDistance: number, undoable?: boolean): void;
}

export function BaseItemCustomShadowDistanceOption({className = '', ...props}: BaseItemCustomShadowDistanceOptionProps): ReactElement<any> | null {
  const onChangeDistance = (updatedDistance: number): void => {
    props.onUpdateDistance(updatedDistance, false);
  };

  const onChangeDistanceEnded = (updatedDistanceupdatedDistance: number): void => {
    props.onUpdateDistance(updatedDistanceupdatedDistance);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-shadow-distance"
      className={className}
      value={props.dropShadowDistance}
      label={window.i18next.t('pmwjs_distance')}
      range={{
        min: CUSTOM_SHADOW_MIN_DISTANCE,
        max: CUSTOM_SHADOW_MAX_DISTANCE,
      }}
      transformDisplay={{
        min: CUSTOM_SHADOW_MIN_DISTANCE,
        max: CUSTOM_SHADOW_MAX_DISTANCE,
      }}
      onChange={onChangeDistance}
      onChangeEnded={onChangeDistanceEnded}
    />
  );
}
